module.exports = __webpack_public_path__ + "static/media/petal1.20125fd1.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/spinners/petal1.svg
 ** module id = 2314
 ** module chunks = 50
 **/